import { cn } from "@/lib/utils";
import { MapPin } from "lucide-react";

export const TraceabilityPanel = ({
  traceability,
  materialComposition,
  className,
  title,
  subtitle,
  showHeader = true
}) => {
  if (!traceability) return null;

  return (
    <div className={cn("bg-card rounded-xl border border-border overflow-hidden", className)}>
      {showHeader && (
        <div className="bg-secondary/30 px-6 py-4 border-b border-border">
          <div className="flex items-center justify-between">
            <h3 className="font-display text-lg font-semibold text-foreground">
              {title || "Traceability"}
            </h3>
          </div>
          <p className="text-sm text-muted-foreground mt-1">
            {subtitle || "Follow the complete journey of your product"}
          </p>
        </div>
      )}

      {/* Content */}
      <div className="p-6">
        {/* Material Composition */}
        <div className="mb-6 pb-6 border-b border-border">
          <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
            Material Composition
          </span>
          <p className="text-base font-medium text-foreground mt-1">{materialComposition}</p>
        </div>

        {/* Production Timeline */}
        <div>
          <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
            Production Timeline
          </span>
          <div className="mt-4 space-y-0">
            {traceability.steps.map((step, index) => (
              <div
                key={index}
                className="relative pl-8 pb-6 last:pb-0 stagger-item"
                style={{ "--stagger-delay": `${index * 120}ms` }}
              >
                {/* Timeline line */}
                {index < traceability.steps.length - 1 && (
                  <div className="absolute left-[11px] top-6 w-px h-full bg-border" />
                )}
                {/* Timeline dot */}
                <div className="absolute left-0 top-1 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary" />
                </div>
                {/* Content */}
                <div>
                  <h4 className="font-medium text-foreground">{step.name}</h4>
                  <div className="mt-1 space-y-1">
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                      <span className="font-medium">{step.partner}</span>
                    </div>
                    <div className="flex items-center gap-3 text-xs text-muted-foreground">
                      <span className="flex items-center gap-1">
                        <MapPin className="h-3 w-3" />
                        {step.location}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Last Updated */}
        <div className="mt-6 pt-4 border-t border-border">
          <p className="text-xs text-muted-foreground">
            Last updated: {traceability.lastUpdated}
          </p>
        </div>
      </div>
    </div>
  );
};
